/** Export-toast suffix counting the cc'd recipients, or an empty string when there are none. */
export function ccRecipientsNotice(ccEmails?: string[]): string {
  const count = ccEmails?.length ?? 0;
  if (count === 0) return '';
  return ` A copy will also go to ${count} cc'd ${count === 1 ? 'recipient' : 'recipients'}.`;
}
